import { VelaMark } from './VelaMark';
import { LINKS } from '../config';

export function Footer() {
  return (
    <footer className="border-t border-white/[0.05] bg-midnight-950 py-14">
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-8 px-6 sm:flex-row sm:items-center">
        <div className="flex items-center gap-2.5">
          <VelaMark size={26} />
          <div>
            <p className="text-sm text-star">Vela Wallet</p>
            <p className="text-xs text-mist/60">
              Built for the{' '}
              <a href={LINKS.midnightNetwork} className="underline decoration-white/20 underline-offset-4 hover:text-mist">
                Midnight network
              </a>
            </p>
          </div>
        </div>

        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-mist">
          <a href={LINKS.github} className="hover:text-star">
            GitHub
          </a>
          <a href={LINKS.securityPolicy} className="hover:text-star">
            Security policy
          </a>
          <a href="#faq" className="hover:text-star">
            FAQ
          </a>
        </nav>
      </div>

      <p className="mx-auto mt-10 max-w-6xl px-6 text-xs text-mist/50">
        Vela Wallet is audit-pending software. Review the security policy before entrusting it with mainnet funds.
      </p>
    </footer>
  );
}
